import createField from '../createField';
import immutable from '../structure/immutable';

export default createField(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/Field.js
// module id = 1190
// module chunks = 0